<template>
    <div class="card-body p-0 project-info-card">
        <div class="project-info-area">
            <b-row class="project-info">
                <b-col cols="4" class="pr-0">
                    <span>Description</span>
                </b-col>
                <b-col cols="7" class="pl-1 content-box">
                    <span class="content-text">{{ projectInformation['Description'] }}</span>
                </b-col>
            </b-row>
 
            <b-row class="project-info">
                <b-col cols="4" class="pr-0">
                    <span>Period</span>
                </b-col>
                <b-col cols="7" class="pl-1 content-box date" v-if="projectInformation['Start'] === '' && projectInformation['End'] === ''">
                    <span>
                        N/A
                    </span>
                </b-col>
                <b-col cols="7" class="pl-1 content-box date" v-else>
                        <span class="content-text">{{ projectInformation['Start'] }}</span>
                        <span class="content-text"> ~ </span>
                        <span class="content-text" :class="projectInformation.isOverdue ? 'warning' : ''">{{ projectInformation['End'] }}</span>
                </b-col>
            </b-row>
        </div>
        <div class="progress-info-area">
            <b-row class="project-info">
                <b-col class="pr-0">
                <span>Working Days</span>
                </b-col>
                <b-col class="content-box">
                <b-progress :max="projectInformation.workingDays" height="14px" variant="success">
                <b-progress-bar :value="projectInformation.currentWorkingDays">
                    <strong>
                    {{ projectInformation['currentWorkingDays'] }} / {{ projectInformation['workingDays'] }}
                    ({{
                    !isNaN((projectInformation.currentWorkingDays / projectInformation.workingDays))
                        ? ((projectInformation.currentWorkingDays / projectInformation.workingDays) * 100).toFixed(2)
                        : 0
                    }}
                    %)</strong>
                </b-progress-bar>
                </b-progress>
                </b-col>
            </b-row>
            <b-row class="project-info">
                <b-col class="pr-0">
                <span>Progress</span>
                </b-col>
                <b-col class="content-box">
                <b-progress :max="projectInformation.totalProgramCount" height="14px" variant="success">
                <b-progress-bar :value="projectInformation.completedProgramCount">
                    <strong>
                    {{
                    !isNaN((projectInformation.completedProgramCount / projectInformation.totalProgramCount))
                        ? ((projectInformation.completedProgramCount / projectInformation.totalProgramCount) * 100).toFixed(2)
                        : 0
                    }}
                    %</strong>
                </b-progress-bar>
                </b-progress>
                </b-col>
            </b-row>
        </div>
    </div>
</template>
<script>
    export default {
        name : 'ProjectInformationCard',
        props: ['dashboardData'],
        mounted() {
            this.createProjectInformation();
        },
        data() {
            return {
                projectInformation: '',
                // descriptionList: ["ID & Name", "Description", "Start" + " ~ " + "End"],
                descriptionList: ["Description", "Start" + " ~ " + "End"],
                isOverdue: true,
                columnName: {
                    projectId: "ID",
                    projectType: "Type",
                    name: "Name",
                    description: "Description",
                    startDate: "Start Date",
                    endDate: "End Date"
                }
            }
                
        },
        methods: {
            createProjectInformation() {
                let projectInfo = this.dashboardData.projectInfo;

                // 프로그램 진척도 산출
                let total = 0;
                let completed = 0;
                this.dashboardData.currentChatter.forEach(data => {
                total++;
                if(data.status != 'TO_DO' && data.status != 'IN_PROGRESS') {
                    completed++;
                }
                });

                //현재 날짜 산출
                this.isOverdue =  new Date()> new Date(projectInfo.endDate);

                this.projectInformation = {
                    // 'ID & Name': `${projectInfo.projectId} - ${projectInfo.name}`,
                    'Description': projectInfo.description,
                    'Start': `${projectInfo.startDate}`,
                    'End': `${projectInfo.endDate}`,
                    'currentWorkingDays': projectInfo.currentWorkingDays,
                    'workingDays': projectInfo.workingDays,
                    'totalProgramCount': total,
                    'completedProgramCount': completed,
                    'isOverdue': this.isOverdue
                }
            }
        },
    }
</script>

<style scoped>
.project-info-card {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-height: calc(100% - 58px);
    font-family: 'NanumGothic';
}
.project-info:first-child {
    margin-top: 10px;
}
.project-info {
    margin-left: 0;
    margin-right: 0;
    padding: 10px 0;
}
.project-info [class*="col"] {
    padding: 0;
}
.project-info .content-box {
    flex-grow: 1;
    max-width: unset;
}
.project-info span {
    display: -webkit-box;
    font-weight: 500;
    font-size: clamp(10px, 0.7291vw, 14px);
    line-height: 1.5;
}
.project-info .content-text {
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: break-word;
    font-weight: 700;
    -webkit-line-clamp: 3; 
    -webkit-box-orient: vertical;
}
.progress-info-area {
    padding: 0 0 15px;
    border-top: 1px solid #dee2e6 !important;
}
.progress-info-area .project-info {
    padding: 10px 0 0;
}
.progress-info-area .content-box {
    flex-basis: 100%;
    width: 100%;
}
.progress {
    position: relative;
    margin-top: 4px;
    border-radius: 14px;
    background: #D8E7FF;
    overflow: hidden;
}
.progress-bar {
    border-radius: 14px 0 0 14px;
    font-size: 12px;
    text-align: left;
    overflow: visible;
}
.progress-bar strong {
    padding-left: 10px;
}
.bg-success {
    background-color: #142459 !important;
}
.warning {
    color: red;
}

.date{
    display: flex;
    padding-right: 10px;
}
</style>